import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import * as ko from "knockout";
import {Application} from "../application";

export class UndoCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.Undo;
    
    canExecute = ko.computed(() => {
        return this.app.state.canUndo();
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let dfd = $.Deferred();
        
        this.app.apiManager.estimateRows.undo({
            estimateId: this.app.state.estimate()!.id()
        }).done((data) => {
            this.app.state.canUndo(data!.canUndo);
            this.app.state.canRedo(data!.canRedo);

            this.app.state.history(new Date());
            dfd.resolve();
        });
        
            
        return dfd.promise();
    }

    name = "Undo";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/undoCommand.ts